// Home page copy. These are the built-in defaults; an admin can change them in the portal under Website Content
// (see content/siteContentDefaults.js for how each field maps onto this file).
export const HOME = {
  hero: {
    headline: 'Giving voice to the',
    highlight: 'world.',
    sub: 'Phone numbers in 140+ countries, Cloud PBX, SIP trunking and AI voice. One UK provider, one portal.',
    primary: { label: 'Browse numbers', to: '/coverage' },
    secondary: { label: 'Get started', to: '/contact' },
    image: '/media/site/hero-earth.webp',
    video: '/media/site/hero-earth.mp4',
    videoWebm: '/media/site/hero-earth.webm',
  },
  products: {
    title: 'Everything your calls need',
    subtitle: 'Numbers, connectivity and voice applications from a single provider.',
  },
  platform: {
    title: 'Manage numbers and connections in one portal',
    body: 'Order numbers, point them at your SIP endpoints and set up failover, all from the VOIP2 customer portal.',
    bullets: [
      'Provision numbers and see them live straight away',
      'Route calls to SIP, Cloud PBX or mobile with failover',
      'Track usage, invoices and support tickets in one place',
    ],
    linkLabel: 'Sign in to the portal',
  },
  useCases: {
    title: 'Built for teams that live on the phone',
    subtitle: 'Find your team below and jump straight to the products that fit.',
    items: [
      {
        title: 'Contact centres',
        tag: 'Inbound at scale',
        body: 'Freephone and local numbers that land in your queues, wherever your agents sit.',
        links: [['Toll-Free', '/phone-numbers/toll-free'], ['UIFN', '/phone-numbers/uifn'], ['Cloud PBX', '/products/cloud-pbx']],
      },
      {
        title: 'Fintech and apps',
        tag: 'Verification',
        body: 'Verify sign-ups and logins with a flash call instead of an SMS code.',
        links: [['Voice OTP', '/products/voice-otp'], ['Mobile Numbers', '/phone-numbers/mobile']],
      },
      {
        title: 'Growing businesses',
        tag: 'Small & mid-size teams',
        body: 'A professional phone system with local numbers and a receptionist that never takes a day off.',
        links: [['Cloud PBX', '/products/cloud-pbx'], ['AI Receptionist', '/products/ai-receptionist'], ['DID Numbers', '/phone-numbers/did-international']],
      },
      {
        title: 'Carriers and resellers',
        tag: 'Wholesale',
        body: 'Wholesale numbers and SIP connectivity to build your own voice services on.',
        links: [['SIP Trunking', '/products/sip-trunking'], ['2-Way Numbers', '/phone-numbers/2way']],
      },
    ],
  },
  steps: {
    title: 'Live in three moves',
    items: [
      { verb: 'Choose', body: 'Pick numbers by country, city and type from our coverage list.' },
      { verb: 'Verify', body: 'Some countries ask for proof of identity or address. Upload it once in the portal.' },
      { verb: 'Connect', body: 'Route calls to your SIP trunk, Cloud PBX or mobile, with failover if you need it.' },
    ],
  },
  cta: {
    title: 'Ready when your customers call',
    subtitle: 'Tell us what you need and we will put together numbers, routing and pricing for you.',
    primaryLabel: 'Get started',
    secondaryLabel: 'Browse numbers',
  },
  logoSlots: 7,
};
